<template>
  <div>
    <div>
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            
            <tr>
              <td>{{ $t("centered-coordinates") }}</td>
              <td>{{ objectItem.OBJ_COO }}</td>
            </tr>
            <tr>
              <td>{{ $t("object-type") }}</td>
              <td>{{ objectItem.OBJ_TYP }}</td>
            </tr>
            <tr>
              <td>{{ $t("number-of-floors") }}</td>
              <td>{{ objectItem.OBJ_FLO }}</td>
            </tr>
            <tr>
              <td>{{ $t("number-of-units") }}</td>
              <td>{{ objectItem.OBJ_UNI }}</td>
            </tr>
            <tr>
              <td><b>{{ $t("year-of-construction") }}</b></td>
              <td><b>{{ objectItem.OBJ_JOB }}</b></td>
            </tr>
            <tr>
              <td>{{ $t("construction-period") }}</td>
              <td>{{ objectItem.OBJ_POB }}</td>
            </tr>
            <tr>
              <td>{{ $t("listed") }}</td>
              <td>{{ objectItem.OBJ_PRO }}</td>
            </tr>
            <tr>
              <td>{{ $t("municipality") }}</td>
              <td>{{ objectItem.OBJ_MUN }}</td>
            </tr>
            <tr>
              <td>{{ $t("postal-code") }}</td>
              <td>{{ objectItem.OBJ_ZIP }}</td>
            </tr>
            <tr>
              <td>{{ $t("street") }}</td>
              <td>{{ objectItem.OBJ_STR }}</td>
            </tr>
            <tr>
              <td>{{ $t("number") }}</td>
              <td>{{ objectItem.OBJ_STN }}</td>
            </tr>
            
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails200 extends Vue {
  @Prop()
  plotItem

  @Prop()
  objectItem
}
</script>

